import React from "react";
import { Picker } from "@design-system/Picker/Picker.lib";
import type { PickerItemData } from "@design-system/Picker/Picker.types";

interface Props {
    items: Array<PickerItemData<string>>;
    value: string | null;
    onChange: (id: string | null) => void;
}

export const ReassignRoleTargetCombobox: React.FC<Props> = ({
    items,
    value,
    onChange,
}) => (
    <Picker.Select
        items={items}
        searchable
        searchPlaceholder="Search accounts…"
        emptyLabel="No matching accounts"
        value={value}
        onValueChange={onChange}
        placeholder="Select account"
        trigger={<Picker.Button variant="primary" size="xl" block />}
    />
);
